import React, { useEffect, useState } from 'react';
// import { courseCategories, dummyQuizzes } from '../../../../types/course';
import Logo from '../../../../assets/dashboard/logo.png'
import save_icon from '../../../../assets/dashboard/save-icon.svg'
import upload_icon from '../../../../assets/dashboard/upload-icon.svg'
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import * as Yup from 'yup';
import './Form.css'
import { addCourse, getCoursesById, updateCourse } from '../../../../services/Trainer/trainer';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const CourseForm = ({ onSubmit, onCancel }) => {
  const navigate = useNavigate()
  const [expandedSections, setExpandedSections] = useState({
    curriculum: false,
    materials: false,
    quizzes: false,
    thumbnail: false,
  });
  const [thumbnailState, setThumbnailState] = useState({
    file: null,
    existingUrl: '',
    isEditing: false,
  });
  const [expanded, setExpanded] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState({
    title: '',
    category: '',
    description: '',
    tags: [],
    videos: [],
    courseMaterials: [],
    thumbnail: null,
    thumbnailUrl: '',
    quizes: [],
    newQuiz: {
      type: 'mcq',
      question: '',
      options: ['', '', '', ''],
      correctOptionIndex: '',
    },
  });
  const [loading, setLoading] = useState(false);
  const toggleSection = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const fetchData = async () => {
    let data = await getCoursesById(id);
    if (data?.success) {
      console.log("data>>><<<<<<<", data)
      const courseData = data.data;

      // Set initial values for editing
      setInitialValues({
        title: courseData.course.title || '',
        category: courseData.course.category || '', // Add this field to your API response if needed
        description: courseData.course.description || '',
        tags: courseData.course.tags || [],
        videos: courseData.content.videos.map(video => ({
          title: video.title,
          file: null,
          videoUrl: video.videoUrl, // Store existing URL
          isEditing: false,
          isExisting: true,// Flag to identify existing videos
          duration: video.duration,
          _id: video._id
        })) || [],
        courseMaterials: courseData.content.courseMaterials.map(material => ({
          title: material.title,
          file: null,
          materialUrl: material.materialUrl, // Store existing URL
          isEditing: false,
          isExisting: true // Flag to identify existing materials
        })) || [],
        thumbnail: null,
        thumbnailUrl: courseData.course.thumbnail, // Store existing thumbnail URL
        quizes: courseData.content.quizes || [],
        newQuiz: {
          question: '',
          options: ['', '', '', ''],
          correctOptionIndex: '',
        },
      });

      // Set thumbnail state if exists
      if (courseData.course.thumbnail) {
        setThumbnailState({
          file: null,
          existingUrl: courseData.course.thumbnail
        });
      }
      if (courseData.content.quizes) {
        setExpanded(true)
      }
    }
  }

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [])

  // const validationSchema = Yup.object({
  //   title: Yup.string().required('Course Title is required'),
  //   category: Yup.string().required('Course Category is required'),
  //   description: Yup.string().required('Course Description is required'),
  //   tags: Yup.array().min(1, 'At least one tag is required'),
  // });

  const validationSchema = Yup.object({
    title: Yup.string().required('Course Title is required'),
    category: Yup.string().required('Course Category is required'),
    description: Yup.string().required('Course Description is required'),
    tags: Yup.array()
      .min(1, 'At least one tag is required')
      .required('Tags are required'),

    videos: Yup.array()
      .min(1, 'At least one video is required'),

    courseMaterials: Yup.array()
      .min(1, 'At least one course material is required'),

    quizes: Yup.array()
      .min(1, 'At least one quiz is required'),

    thumbnail: Yup.mixed()
      .nullable() // Allow null or undefined
      .test(
        'thumbnail-required',
        'Thumbnail is required',
        function (value) {
          const { thumbnailUrl } = this.parent;
          return !!value || !!thumbnailUrl;
        }
      ),
  });
  const handleSubmit = async (values, { resetForm }) => {
    console.log("values>>>>>..", values)
    const formData = new FormData();

    // Basic fields
    formData.append('category', values.category);

    formData.append('title', values.title);
    formData.append('description', values.description);

    // Tags
    values.tags.forEach((tag) => {
      formData.append('tags', tag);
    });

    // Quizzes
    const quizzes = values.quizes.map(q => ({
      question: q.question,
      correctOption: q.correctOption,
      options: q.options
    }));
    formData.append('quizes', JSON.stringify(quizzes));

    // Course Materials metadata - handle both new and existing
    const courseMaterials = values.courseMaterials.map(m => ({
      title: m.title || '',
      materialUrl: m.isExisting && !m.file ? m.materialUrl : '' // Use existing URL if not changed
    }));
    formData.append('courseMaterials', JSON.stringify(courseMaterials));

    // Course Material files - only append new files
    values.courseMaterials.forEach(m => {
      if (m.file && m.title) {
        formData.append(`material_${m.title}`, m.file);
      }
    });

    // Videos metadata - handle both new and existing
    const videos = values.videos.map(v => ({
      title: v.title,
      videoUrl: v.isExisting && !v.file ? v.videoUrl : '',// Use existing URL if not changed
      duration: v.duration,
      _id: v._id
    }));
    formData.append('videos', JSON.stringify(videos));

    // Video files - only append new files
    values.videos.forEach(v => {
      if (v.file && v.title) {
        formData.append(`video_${v.title}`, v.file);
      }
    });

    // Thumbnail - handle both new and existing
    if (values.thumbnail) {
      formData.append('thumbnail', values.thumbnail);
    } else if (values.thumbnailUrl) {
      formData.append('thumbnail', values.thumbnailUrl);
    }

    // Add course ID for edit mode
    // if (id) {
    //   formData.append('courseId', id);
    // }

    setLoading(true);
    try {
      const result = id ? await updateCourse(formData, id) : await addCourse(formData); // You'll need to create updateCourse function
      console.log('Course processed successfully:', result);
      if (result?.success) {
        if (!id) resetForm(); // Only reset form for new courses
        setLoading(false)
        toast.success(result?.message);
        navigate(-1);
      }
      else {
        setLoading(false)
        toast.error(result?.message);
      }
    } catch (err) {
      console.error('Failed to process course:', err);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="card shadow">
      <div className="d-flex align-items-center justify-content-center mt-4">
        <div className="text-center mb-4">
          <img src={Logo || "/placeholder.svg"} alt="Logo" width={100} />
        </div>
      </div>
      <h2 className="text-center fs-4 fw-bold mb-4 text-color">
        {id ? 'Edit Course' : 'Add Course'}
      </h2>

      <div className="card-body">
        <Formik
          initialValues={initialValues}
          enableReinitialize={true} // Allow form to reinitialize when initialValues change
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form className="mb-4 px-4">
              {/* Basic Info */}
              <div className="form-wrapper">
                <div className="form-group mb-4">
                  <Field
                    name="title"
                    type="text"
                    placeholder="Course Title"
                    className="custom-input"
                  />
                  <ErrorMessage name="title" component="div" className="error-text" />
                </div>
                <div className="form-group mb-4">
                  <Field
                    as="select"
                    name="category"
                    className="custom-select"
                  >
                    <option value="" disabled>Course Category</option>
                      <option value="HIFU">HIFU</option>
  <option value="Facial & Body Waxing">Facial & Body Waxing</option>
  <option value="Facial Tinting">Facial Tinting</option>
  <option value="Brow Lamination">Brow Lamination</option>
  <option value="Lash Lift">Lash Lift</option>
  <option value="Full Glam, Brows & Lashes">Full Glam, Brows & Lashes</option>
  <option value="Teeth Whitening">Teeth Whitening</option>
  <option value="Head Spa">Head Spa</option>
  <option value="LED Therapy">LED Therapy</option>
  <option value="Dermaplaning">Dermaplaning</option>
  <option value="Carbon Laser Facial">Carbon Laser Facial</option>
                  </Field>
                  <ErrorMessage name="category" component="div" className="error-text" />
                </div>
                {/* Course Description */}
                <div className="form-group mb-4">
                  <Field
                    as="textarea"
                    name="description"
                    placeholder="Course Description"
                    className="custom-input custom-textarea"
                    rows="5"
                  />
                  <ErrorMessage name="description" component="div" className="error-text" />
                </div>

                {/* Course Tags */}
                <div className="form-group mb-4">
                  <FieldArray name="tags">
                    {({ push, remove, form }) => {
                      const { values } = form;
                      return (
                        <div>
                          <div className="tag-container">
                            {values.tags.map((tag, index) => (
                              <span
                                key={index}
                                className="badge bg-light text-dark me-2 d-inline-flex align-items-center"
                                style={{ backgroundColor: '#f7f7f7' }}
                              >
                                {tag}
                                <button
                                  type="button"
                                  onClick={() => remove(index)}
                                  className="btn btn-sm btn-link p-0 ms-2 text-muted"
                                  aria-label="Remove tag"
                                >
                                  <i className="bi bi-x"></i>
                                </button>
                              </span>
                            ))}
                          </div>
                          <input
                            type="text"
                            placeholder="Enter tag and press Enter"
                            className="custom-input"
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                const tag = e.target.value.trim();
                                if (tag) {
                                  push(tag);
                                  e.target.value = ''; // Clear input field
                                }
                              }
                            }}
                          />
                        </div>
                      );
                    }}
                  </FieldArray>
                  <ErrorMessage name="tags" component="div" className="error-text" />
                </div>
              </div>

              {/* Curriculum Section */}
              <FieldArray name="videos">
                {({ push, remove, form }) => {
                  const { values, setFieldValue } = form;
                  const { videos } = values;

                  const savedVideos = videos.filter(v => v.title && (v.file || v.isExisting) && !v.isEditing);
                  const editingVideos = videos.filter(v => v.isEditing);

                  return (
                    <>
                      <h2 className=" fw-bold  text-color mt-5">Add Curriculum</h2>
                      <div className='d-flex align-items-center justify-content-between py-3'>
                        <p className="upload-subtitle text-color">Upload Videos</p>

                        <button
                          type="button"
                          className="add-video-btn"
                          onClick={() => push({ title: '', file: null, isEditing: true })}
                        >
                          + Video
                        </button>
                      </div>

                      {/* 📦 Show all saved videos in one box */}
                      {savedVideos.length > 0 && (
                        <div className="video-card-container">
                          <div className="video-card-header">
                            <strong>Videos</strong>
                          </div>
                          <table className="video-info-table">
                            <thead>
                              <tr>
                                <th>File Name</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Edit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                console.log("askjdhfkjsadf", savedVideos)
                              }
                              {savedVideos.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.isExisting ? item.title : item.title}</td>
                                  <td>Video</td>
                                  <td>{item.isExisting ? 'Uploaded' : 'Ready'}</td>
                                  <td>
                                    <span
                                      type=""
                                      className="border-bottom text-color"
                                      onClick={() => {
                                        const idx = videos.findIndex(
                                          v => v.title === item.title && (v.file === item.file || v.videoUrl === item.videoUrl)
                                        );
                                        setFieldValue(`videos[${idx}].isEditing`, true);
                                      }}
                                    >
                                      Edit
                                    </span>
                                  </td>
                                </tr>
                              ))}
                              {/* <tr>
                                <td colSpan={4}>
                                  <p className="video-note">
                                    <strong>Note:</strong> Videos are being processed. You'll get an email when they're ready.
                                  </p>
                                </td>
                              </tr> */}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* 📝 Editable form blocks */}
                      {videos.map((item, index) => {
                        if (!item.isEditing) return null;

                        return (
                          <div className="video-card-container" key={index}>
                            <div className="video-card-header">
                              <div>
                                <span className="video-label ">Video</span>
                                <span className="aesthetic-wellness">Aesthetic Wellness</span>
                              </div>

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => remove(index)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </div>

                            <p className="video-description">
                              Please add a video title and upload a video. Files and links can be added as resources.
                            </p>

                            <div className="video-input-container">
                              <input
                                type="text"
                                className="video-title-input"
                                placeholder="Video Title"
                                value={item.title}
                                onChange={(e) =>
                                  setFieldValue(`videos[${index}].title`, e.target.value)
                                }
                              />
                              <div className="video-upload-icons">
                                <label className="upload-icon">
                                  {/* <i className="bi bi-cloud-upload"></i> */}
                                  <img src={upload_icon || "/placeholder.svg"} alt="upload" />
                                  <input
                                    type="file"
                                    accept="video/*"
                                    hidden
                                    onChange={(e) => {
                                      if (e.target.files[0]) {
                                        setFieldValue(`videos[${index}].file`, e.target.files[0]);
                                      }
                                    }}
                                  />
                                </label>
                                <span className="attachment-icon"
                                  onClick={() => {
                                    if (item.title && (item.file || item.isExisting)) {
                                      setFieldValue(`videos[${index}].isEditing`, false);
                                    }
                                  }}
                                  style={{
                                    cursor: (item.title && (item.file || item.isExisting)) ? 'pointer' : 'not-allowed',
                                    opacity: (item.title && (item.file || item.isExisting)) ? 1 : 0.5
                                  }}
                                >
                                  {/* <i className="bi bi-paperclip"></i> */}
                                  <img src={save_icon || "/placeholder.svg"} alt="upload" />
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  );
                }}
              </FieldArray>
              {errors.videos && touched.videos && (
                <div className="error-text">{errors.videos}</div>
              )}
              {/* Materials Section */}
              <FieldArray name="courseMaterials">
                {({ push, remove, form }) => {
                  const { values, setFieldValue } = form;
                  const { courseMaterials } = values;

                  const savedMaterials = courseMaterials.filter(m => m.title && (m.file || m.isExisting) && !m.isEditing);
                  const editingMaterials = courseMaterials.filter(m => m.isEditing);

                  return (
                    <>
                      <div className='d-flex align-items-center justify-content-between py-3'>
                        <p className="upload-subtitle text-color">Upload Course Material</p>

                        <button
                          type="button"
                          className="add-video-btn"
                          onClick={() => push({ title: '', file: null, isEditing: true })}
                        >
                          + File
                        </button>
                      </div>

                      {/* 📦 Show all saved materials in one box */}
                      {savedMaterials.length > 0 && (
                        <div className="video-card-container">
                          <div className="video-card-header">
                            <strong>Course Materials</strong>
                          </div>
                          <table className="video-info-table">
                            <thead>
                              <tr>
                                <th>File Name</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Edit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {savedMaterials.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.isExisting ? item.title : item.file.name}</td>
                                  <td>Document</td>
                                  <td>{item.isExisting ? 'Uploaded' : 'Ready'}</td>
                                  <td>
                                    <span
                                      type=""
                                      className="border-bottom text-color"
                                      onClick={() => {
                                        const idx = courseMaterials.findIndex(
                                          m => m.title === item.title && (m.file === item.file || m.materialUrl === item.materialUrl)
                                        );
                                        setFieldValue(`courseMaterials[${idx}].isEditing`, true);
                                      }}
                                    >
                                      Edit
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* 📝 Editable form blocks */}
                      {courseMaterials.map((item, index) => {
                        if (!item.isEditing) return null;

                        return (
                          <div className="video-card-container" key={index}>
                            <div className="video-card-header">
                              <div>
                                <span className="video-label ">Course Material</span>
                                <span className="aesthetic-wellness">Aesthetic Wellness</span>
                              </div>

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => remove(index)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </div>

                            <p className="video-description">
                              Please add a file title and upload a file.
                            </p>

                            <div className="video-input-container">
                              <input
                                type="text"
                                className="video-title-input"
                                placeholder="File Title"
                                value={item.title}
                                onChange={(e) =>
                                  setFieldValue(`courseMaterials[${index}].title`, e.target.value)
                                }
                              />
                              <div className="video-upload-icons">
                                <label className="upload-icon">
                                  <i className="bi bi-cloud-upload"></i>
                                  <input
                                    type="file"
                                    accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.xls,.xlsx"
                                    hidden
                                    onChange={(e) => {
                                      if (e.target.files[0]) {
                                        setFieldValue(`courseMaterials[${index}].file`, e.target.files[0]);
                                      }
                                    }}
                                  />
                                </label>
                                <span className="attachment-icon"
                                  onClick={() => {
                                    if (item.title && (item.file || item.isExisting)) {
                                      setFieldValue(`courseMaterials[${index}].isEditing`, false);
                                    }
                                  }}
                                  style={{
                                    cursor: (item.title && (item.file || item.isExisting)) ? 'pointer' : 'not-allowed',
                                    opacity: (item.title && (item.file || item.isExisting)) ? 1 : 0.5
                                  }}
                                >
                                  <img src={save_icon || "/placeholder.svg"} alt="upload" />
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  );
                }}
              </FieldArray>
              {errors.courseMaterials && touched.courseMaterials && (
                <div className="error-text">{errors.courseMaterials}</div>
              )}
              {/* <ErrorMessage name="courseMaterials" component="div" className="error-text" /> */}
              {/* Quizzes Section */}
              <div className="mb-3">
                <div className='d-flex align-items-center justify-content-between py-3'>
                  <p className="upload-subtitle text-color">Upload Quiz</p>

                  <button
                    type="button"
                    className="add-video-btn"
                    onClick={() => setExpanded(!expanded)}
                  >
                    + Quiz
                  </button>
                </div>

                {expanded && (
                  <FieldArray name="quizes">
                    {({ push, remove, replace }) => (
                      <div className="video-card-container">
                        {/* Add/Edit Form */}
                        <h5 className="mb-3">{editIndex !== null ? 'Edit Quiz' : 'Add Quiz'}</h5>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Question Type</label>
                          <div className="d-flex gap-4">
                            {/* MCQ radio */}
                            <div className="form-check">
                              <input
                                id="type-mcq"
                                type="radio"
                                name="questionType"
                                className="form-check-input"
                                checked={values.newQuiz.type === 'mcq'}
                                onChange={() => {
                                  setFieldValue('newQuiz', {
                                    ...values.newQuiz,
                                    type: 'mcq',
                                    question: '',
                                    options: ['', '', '', ''],
                                    correctOptionIndex: null,
                                    correctOption: '',
                                  });
                                }}
                              />
                              <label htmlFor="type-mcq" className="form-check-label">MCQs</label>
                            </div>

                            {/* True / False radio */}
                            <div className="form-check">
                              <input
                                id="type-tf"
                                type="radio"
                                name="questionType"
                                className="form-check-input"
                                checked={values.newQuiz.type === 'truefalse'}
                                onChange={() => {
                                  setFieldValue('newQuiz', {
                                    ...values.newQuiz,
                                    type: 'truefalse',
                                    question: '',
                                    options: ['True', 'False'],   // static for TF
                                    correctOptionIndex: null,
                                    correctOption: '',
                                  });
                                }}
                              />
                              <label htmlFor="type-tf" className="form-check-label">True / False</label>
                            </div>
                          </div>
                        </div>
                        {/* <div className="mb-3">
                          <label className="form-label fw-semibold">Question</label>
                          <Field
                            name="newQuiz.question"
                            className="form-control"
                            placeholder="Enter the quiz question"
                          />
                        </div> */}
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Question</label>
                          <Field
                            name="newQuiz.question"
                            className="form-control"
                            placeholder="Enter the quiz question"
                          />
                        </div>

                        {/* Options with radio check for correct */}
                        {/* {values.newQuiz.options.map((opt, idx) => (
                          <div
                            key={idx}
                            className="d-flex align-items-center gap-3 mb-2"
                          >
                            <Field
                              name={`newQuiz.options[${idx}]`}
                              className="form-control"
                              placeholder={`Option ${idx + 1}`}
                            />
                          </div>
                        ))} */}
                        {values.newQuiz.type === 'mcq' ? (
                          <>
                            {/* ---- MCQ OPTIONS (your original markup kept verbatim) ---- */}
                            {values.newQuiz.options.map((opt, idx) => (
                              <div key={idx} className="d-flex align-items-center gap-3 mb-2">
                                <Field
                                  name={`newQuiz.options[${idx}]`}
                                  className="form-control"
                                  placeholder={`Option ${idx + 1}`}
                                />
                              </div>
                            ))}

                            <div className="form-text text-muted mb-2 mt-4">
                              <strong>Please select the correct answer below</strong>
                            </div>
                            <div className="d-flex gap-5 mb-2">
                              {[0, 1, 2, 3].map((idx) => (
                                <div key={idx} className="form-check d-flex mb-2">
                                  <input
                                    className="form-check-input me-1"
                                    type="radio"
                                    name="correctAnswer"
                                    id={`correct-${idx}`}
                                    checked={values.newQuiz.correctOptionIndex === idx}
                                    onChange={() => setFieldValue('newQuiz.correctOptionIndex', idx)}
                                  />
                                  <label htmlFor={`correct-${idx}`} className="form-check-label small">
                                    Option {idx + 1}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <>
                            {/* ---- TRUE / FALSE ---- */}
                            <div className="form-text text-muted mb-2 mt-4">
                              <strong>Please select the correct answer below</strong>
                            </div>
                            <div className="d-flex gap-5 mb-2">
                              {['True', 'False'].map((val) => (
                                <div key={val} className="form-check d-flex mb-2">
                                  <input
                                    className="form-check-input me-1"
                                    type="radio"
                                    name="correctAnswerTF"
                                    id={`tf-${val}`}
                                    checked={values.newQuiz.correctOption === val}
                                    onChange={() => setFieldValue('newQuiz.correctOption', val)}
                                  />
                                  <label htmlFor={`tf-${val}`} className="form-check-label small">
                                    {val}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {/* Label below the options */}
                        {/* <div className="form-text text-muted  mb-2 mt-4">
                          <strong>Please select the correct answer below</strong>
                        </div>
                        <div className=" d-flex gap-5  mb-2">
                          {[0, 1, 2, 3].map((idx) => (
                            <div key={idx} className="form-check d-flex  mb-2">
                              <input
                                className="form-check-input me-1"
                                type="radio"
                                name="correctAnswer"
                                id={`correct-${idx}`}
                                checked={values.newQuiz.correctOptionIndex === idx}
                                onChange={() => setFieldValue('newQuiz.correctOptionIndex', idx)}
                              />
                              <label htmlFor={`correct-${idx}`} className="form-check-label small">
                                Option {idx + 1}
                              </label>
                            </div>
                          ))}
                        </div> */}
                        {
                          console.log("sadasdfasdf", errors)
                        }
                        {/* Add or Update Button */}
                        <div className="mt-2">
                          <button
                            type="button"
                            className="btn btn-success me-2"
                            // disabled={
                            //   !values.newQuiz.question.trim() ||
                            //   values.newQuiz.options.some((opt) => !opt.trim()) ||
                            //   values.newQuiz.correctOptionIndex === "" ||
                            //   values.newQuiz.correctOptionIndex === null ||
                            //   values.newQuiz.correctOptionIndex === undefined
                            // }
                            disabled={
                              !values.newQuiz.question.trim() ||
                              (values.newQuiz.type === 'mcq'
                                ? (values.newQuiz.options.some((opt) => !opt.trim()) ||
                                values.newQuiz.correctOptionIndex === "" ||
                                  values.newQuiz.correctOptionIndex === null)
                                : values.newQuiz.correctOption === '')
                            }
                            onClick={() => {
                              // const quiz = {
                              //   question: values.newQuiz.question,
                              //   options: values.newQuiz.options,
                              //   correctOption: values.newQuiz.options[values.newQuiz.correctOptionIndex],
                              // };

                              const quiz =
                                values.newQuiz.type === 'mcq'
                                  ? {
                                    type: 'mcq',
                                    question: values.newQuiz.question,
                                    options: values.newQuiz.options,
                                    correctOption: values.newQuiz.options[values.newQuiz.correctOptionIndex],
                                  }
                                  : {
                                    type: 'truefalse',
                                    question: values.newQuiz.question,
                                    options: ['True', 'False'],
                                    correctOption: values.newQuiz.correctOption,
                                  };

                              if (editIndex !== null) {
                                replace(editIndex, quiz);
                                setEditIndex(null);
                              } else {
                                push(quiz);
                              }

                              // Reset form
                              setFieldValue('newQuiz', {
                                type: values.newQuiz.type,
                                question: '',
                                options: ['', '', '', ''],
                                correctOptionIndex: null,
                              });
                            }}
                          >
                            {editIndex !== null ? 'Update Quiz' : 'Add Quiz'}
                          </button>
                        </div>

                        {/* Quiz Display List */}
                        {
                          console.log("valuesvalues", values)
                        }
                        <div className="mt-5">
                          <h5>Entered Quizzes</h5>
                          {values.quizes.length === 0 ? (
                            <p className="text-muted">No quizzes added yet.</p>
                          ) : (
                            values.quizes.map((quiz, index) => (
                              <div
                                key={index}
                                className="border rounded p-3 mb-3 bg-light shadow-sm"
                              >
                                <div>
                                  <div style={{ float: 'inline-end' }}>
                                    <span
                                      style={{ marginRight: '8px' }}
                                      type="button"
                                      className="btn btn-sm btn-outline-secondary edit-btn "
                                      onClick={() => {
                                        // setEditIndex(index);
                                        // // setFieldValue('newQuiz', [...quiz,correctOption]);

                                        // const correctOptionIndex = quiz.options.indexOf(quiz.correctOption);

                                        // setFieldValue('newQuiz', {
                                        //   question: quiz.question,
                                        //   options: quiz.options,
                                        //   correctOptionIndex: correctOptionIndex !== -1 ? correctOptionIndex : null
                                        // });
                                        setEditIndex(index);

                                        if (quiz.type === 'mcq') {
                                          const correctOptionIndex = quiz.options.indexOf(quiz.correctOption);
                                          setFieldValue('newQuiz', {
                                            type: 'mcq',
                                            question: quiz.question,
                                            options: quiz.options,
                                            correctOptionIndex: correctOptionIndex !== -1 ? correctOptionIndex : null,
                                            correctOption: '',
                                          });
                                        } else {
                                          setFieldValue('newQuiz', {
                                            type: 'truefalse',
                                            question: quiz.question,
                                            options: ['True', 'False'],
                                            correctOptionIndex: null,
                                            correctOption: quiz.correctOption,
                                          });
                                        }
                                      }}
                                    >
                                      <i className="bi bi-pencil"></i>
                                    </span>
                                    <span
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => remove(index)}
                                    >
                                      <i className="bi bi-trash"></i>
                                    </span>
                                  </div>
                                  <strong>Q{index + 1}:</strong> {quiz.question}
                                  <ul className="mt-2 mb-2">
                                    {quiz.options.map((opt, idx) => (
                                      <li
                                        key={idx}
                                        className={
                                          opt === quiz.correctOption
                                            ? 'fw-bold text-success'
                                            : ''
                                        }
                                      >
                                        {opt}
                                        {opt === quiz.correctOption && ' (Correct)'}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    )}
                  </FieldArray>
                )}
              </div>
              {errors.quizes && touched.quizes && (
                <div className="error-text">{errors.quizes}</div>
              )}
              {/* Thumbnail Section */}
              <div className="mb-3">
                <h2 className="fw-bold text-color mt-5">Course Thumbnail</h2>

                {/* Show thumbnail info in table format */}
                {(thumbnailState.file || thumbnailState.existingUrl) && !thumbnailState.isEditing && (
                  <div className="video-card-container">
                    <div className="video-item">
                      <table className="video-info-table">
                        <thead>
                          <tr>
                            <th>File Name</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{thumbnailState.file ? thumbnailState.file.name : 'Existing Thumbnail'}</td>
                            <td>Image</td>
                            <td>Uploaded</td>
                            <td>
                              <span
                                className="border-bottom text-color"
                                onClick={() =>
                                  setThumbnailState((prev) => ({ ...prev, isEditing: true }))
                                }
                                style={{ cursor: 'pointer' }}
                              >
                                Edit
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Upload area: only show if editing OR adding a new image */}
                {(!thumbnailState.file && !thumbnailState.existingUrl) || thumbnailState.isEditing ? (
                  <div className="video-card-container">
                    <div className="video-card-header">
                      <span className="video-label">Course Thumbnail</span>
                    </div>

                    {/* Show current image if it exists */}
                    {(thumbnailState.file || thumbnailState.existingUrl) && (
                      <div className="current-thumbnail">
                        <p className="current-thumbnail-label">Current Thumbnail:</p>
                        <div className="current-thumbnail-preview" style={{ width: '200px' }}>
                          <img
                            src={
                              thumbnailState.file
                                ? URL.createObjectURL(thumbnailState.file)
                                : `${process.env.REACT_APP_BUCKET_URL}${thumbnailState.existingUrl}`
                            }
                            alt="Current thumbnail"
                            className="thumbnail-image"
                            width={100}
                            height={100}
                          />
                        </div>
                      </div>
                    )}

                    {/* Upload input */}
                    <div className="thumbnail-upload-area">
                      <div className="thumbnail-drop-zone">
                        <div className="thumbnail-upload-icon">
                          <i className="bi bi-cloud-upload" style={{ fontSize: '48px', color: '#ccc' }}></i>
                        </div>
                        <p className="thumbnail-upload-text">
                          {thumbnailState.file ? 'Drag files to replace or' : 'Drag files to upload or'}
                        </p>
                        <label className="thumbnail-choose-btn">
                          {thumbnailState.file ? 'Replace File' : 'Choose File'}
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) => {
                              if (e.target.files[0]) {
                                const file = e.target.files[0];
                                setFieldValue('thumbnail', file);
                                setThumbnailState({
                                  file: file,
                                  existingUrl: null,
                                  isEditing: false,
                                });
                              }
                            }}
                          />
                        </label>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="video-card-actions mt-3">
                      {thumbnailState.file || thumbnailState.existingUrl ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => {
                              setFieldValue('thumbnail', null);
                              setThumbnailState({
                                file: null,
                                existingUrl: null,
                                isEditing: true,
                              });
                            }}
                          >
                            Remove
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary ms-2"
                            onClick={() =>
                              setThumbnailState((prev) => ({
                                ...prev,
                                isEditing: false,
                              }))
                            }
                          >
                            Cancel
                          </button>
                        </>
                      ) : null}
                    </div>
                  </div>
                ) : null}

                {errors.thumbnail && touched.thumbnail && (
                  <div className="error-text">{errors.thumbnail}</div>
                )}
              </div>

              {/* Submit */}
              <div className="mt-4">
                <button type="submit" className=" text-white w-100 py-2 submit-btn"
                  style={{
                    pointerEvents: loading ? 'none' : 'auto',
                    opacity: loading ? 0.6 : 1,
                    cursor: loading ? 'not-allowed' : 'pointer',
                  }}
                >
                  {loading ? 'loading.....' : "Confirm"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 1055,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'all',
          }}
        >
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-dark fw-semibold fs-5">Uploading course content...</p>
        </div>
      )}
    </div>
  );
};

export default CourseForm;